import { z } from "zod";

import { IdeaType } from "../types/entities";
import { ImportField } from "modules/core/components/ImportModal/types";
import { ITableColumn } from "modules/core/types/entities";

export const ideaTypeColorMap: Record<IdeaType, string> = {
  StoryIdea: "#b05bdb",
  StoryHypothesis: "#6772e6",
  StoryTesting: "#73bf7c"
};

export const ideaPrioritiesColors = [
  "#b05bdb",
  "#8b67e6",
  "#6772e6",
  "#5d97f5",
  "#6bcded",
  "#60d0d6",
  "#3fd4b1",
  "#73bf7c",
  "#0e7c7b",
  "#ef798a",
  "#dabfff",
  "#5158bb",
  "#ee4266",
  "#e88d67",
  "#4281a4",
  "#73ab84",
  "#6a687a",
  "#5e4352",
  "#c47335",
  "#49dcb1",
  "#e3879e",
  "#35524a",
  "#1a535c",
  "#7d82b8"
];

export const importIdeaFields: Array<ImportField> = [
  {
    key: "title",
    label: "Title",
    type: "text",
    isRequired: true,
    limit: 191
  },
  {
    key: "description",
    label: "Description",
    type: "text",
    isRequired: false
  },
  {
    key: "hypothesis",
    label: "Hypothesis",
    type: "text",
    isRequired: false
  },
  {
    key: "date",
    label: "Start Date",
    type: "date",
    isRequired: false
  },
  {
    key: "tags",
    label: "Tags",
    type: "list",
    isRequired: false
  }
];

export const importIdeasSchema = z.object({
  title: z
    .string({ required_error: "Title is missing" })
    .min(1, { message: "Title is missing" }),
  description: z.string().optional(),
  hypothesis: z.string().optional(),
  date: z.string().datetime({ message: "Invalid date" }).optional(),
  tags: z.array(z.string()).optional()
});

export const ideasTableColumns: ITableColumn[] = [
  {
    label: "Title",
    key: "title",
    sortKey: "title"
  },
  {
    label: "Description",
    key: "description",
    sortKey: "description"
  },
  {
    label: "Hypothesis",
    key: "hypothesis",
    sortKey: "hypothesis"
  },
  {
    label: "Idea Source",
    key: "source"
  },
  {
    label: "Tags",
    key: "tags"
  },
  {
    label: "Stage",
    key: "type",
    sortKey: "type"
  },
  {
    label: "Priority Score",
    key: "score_total",
    sortKey: "score_total",
    align: "center"
  }
];
